module.exports = __webpack_public_path__ + "img/arrow-up.4127c3bb.svg";